import React, {useEffect} from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import './SharedRefresh.css';
import HomePage from './pages/HomePage';
import AboutUsPage from './pages/AboutUsPage';
import RegulationsPage from './pages/RegulationsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ContactsPage from './pages/ContactsPage';
import BinaryOptionsPage from './pages/BinaryOptionsPage';
import CryptocurrencyPage from './pages/CryptocurrencyPage';
import ForexPage from './pages/ForexPage';
import RomancePage from './pages/RomancePage';
import PropertyPage from './pages/PropertyPage';
import CreditCardPage from './pages/CreditCardPage';
import StockTradingPage from './pages/StockTradingPage';
import OtherPage from './pages/OtherPage';
import CookieConsent from './components/CookieConsent';
import { useScrollReveal } from './hooks/useScrollReveal';

function RoutePosition(){const location=useLocation();useEffect(()=>{const id=location.hash.slice(1);if(id){requestAnimationFrame(()=>document.getElementById(id)?.scrollIntoView());}else window.scrollTo(0,0);},[location.pathname,location.hash]);return null;}
function App() {
  useScrollReveal();

  return (
    <div className="App">
      <BrowserRouter>
        <RoutePosition />
        <a className="tb-skip" href="#page-content">Skip to content</a>
        <div id="page-content" tabIndex={-1}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/regulations" element={<RegulationsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/binary-options" element={<BinaryOptionsPage />} />
          <Route path="/cryptocurrency" element={<CryptocurrencyPage />} />
          <Route path="/forex" element={<ForexPage />} />
          <Route path="/romance" element={<RomancePage />} />
          <Route path="/property" element={<PropertyPage />} />
          <Route path="/credit-card-phishing" element={<CreditCardPage />} />
          <Route path="/stock-trading" element={<StockTradingPage />} />
          <Route path="/other" element={<OtherPage />} />
        </Routes>
        </div>
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
